<template>
    <div class="volet_projet" @click="checkForMobile">
        <div v-if="!loaded" class="container_preload">
            <div class="roulette"></div>
        </div>

        <template v-else-if="loaded">
            <div class="titre-projet donnee" v-html="fiche.intitule"></div>

            <div class="donnee categories">{{ fiche.categorie }}<span class='fine'>&nbsp;</span>:<br>
                <ul class="mots_clefs">
                    <li v-for="mot_clef in fiche.mots_clefs" :key="mot_clef.id">
                        <span @click="goToMotCle(mot_clef)">{{ mot_clef.mot }}</span>
                    </li>
                </ul>
                <div class="images" data-index="0" data-x="0">
                    <div>
                        <div
                            class="image-block"
                            v-for="(image, index) in fiche.images"
                            :data-index="index"

                            @dragstart="disableDrag"
                            @selectstart="disableSelect"

                            @touchstart="getXY"
                            @touchmove="followXY"
                            @touchend="leaveXY"

                            @mousedown="getXY"
                            @mousemove="followXY"
                            @mouseup="leaveXY"
                            @mouseleave="leaveXY"

                            @mouseenter="showLegend"
                            @mouseout="hideLegend"
                        >
                            <div>
                                <img
                                :key="index"
                                :data-index="index"
                                :src="image.url"
                            />
                                <div class="image_vide" v-if="!fiche.images"></div>
                                <div class="legende_image" :class="" :key="index" :id="'legende-'+index">
                                    <span v-if="fiche.images.length > 1">{{ index+1 }} / {{ fiche.images.length }} <br></span>
                                    <span v-if="image.legende">{{ image.legende }} <br></span>
                                    <span v-if="image.credit_photo">© {{ image.credit_photo }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="legende_image_mobilum">
                        <span class="legende_total">1</span>
                        <span class="legende_content">2</span>
                        <span class="legende_rights">3</span>
                    </div>
                </div>
            </div>
            <div class="colonne col2">
                <!-- DEUX TIERS -->
                <div class="donnee" v-if="fiche.objet != ''">
                    Objet<br>{{ fiche.objet }}
                </div>
                <div class="donnee" v-if="fiche.acteurs != ''">
                    Acteur(s)<br>
                    <!-- voir fiche.php de processwire -->
                    <!-- ici -->
                    <ul class="donnee donnee_acteurs">
                        <li class="donnee_acteur" v-for="acteur in fiche.acteurs" :key="acteur.id">
                            <span @click='afficher_acteur(acteur.id)'>{{acteur.nom}}</span>
                        </li>
                    </ul>
                </div>
                <div class="donnee" v-if="fiche.redacteur != ''">
                    Rédacteur(s)<br>{{fiche.redacteur}}
                </div>
                <div class="donnee" v-if="fiche.referencement != ''">
                    Référencement<br><span v-html="fiche.referencement"></span>
                </div>
            </div>
            <div class="colonne col1">
                <!-- UN TIERS -->
                <div class="donnee">
                    <!-- ici -->
                    Année(s)<br><span class="donnee_year" @click='afficher_annee(fiche)'>{{ fiche.annee }}</span>
                </div>
                <div class="donnee" v-if="fiche.duree != 0">
                    Durée<br>{{ retour_duree(fiche.duree) }}
                </div>
                <div class="donnee">
                    <!-- ici/HERE -->
                    Lieu<br>
                    <div>{{ fiche.lieu }}<br>
                        <span
                            v-for="place in fiche.lieu_references"
                            class="donnee_lieu"
                            @mouseenter="showContextual"
                            @mousemove="moveContextual"
                            @mouseleave="hideContextual"
                            >
                            <span>{{ place.name }}</span>
                            <!-- add related_items div -->
                            <div class="contextual_wrapper">
                                <div v-for="rel in place.related_items" class="contextual_file_relation" :data-slug="rel.slug" @click="contextual_chercherObjets(rel.slug)">{{ rel.title }}</div>
                            </div>
                        </span>
                    </div>
                </div>
                <div class="donnee" v-if="fiche.moyens_financiers > 0">
                    Moyens financiers<br>{{ retour_budget(fiche.moyens_financiers) }} euros
                </div>
            </div>

            <div class="separation" v-if="fiche.categorie == 'Expérience pédagogique'">
                <div class="colonne col2">
                <!-- DEUX TIERS -->
                    <div class="donnee" v-if="fiche.ecole">
                        École<br>{{ fiche.ecole }}
                    </div>
                    <div class="donnee" v-if="fiche.responsable_enseignement">
                        Responsable de l‘enseignement<br>{{ fiche.responsable_enseignement }}
                    </div>
                </div>
                <div class="colonne col1">
                    <!-- UN TIERS -->
                    <div class="donnee" v-if="fiche.niveau_etudes">
                        Niveau d’études<br>{{ fiche.niveau_etudes }}
                    </div>
                    <div class="donnee" v-if="fiche.nature_enseignement">
                        Nature<br>{{ fiche.nature_enseignement }}
                    </div>
                </div>
            </div>
    
            <div class="separation">
                <div class="sous_titre">CADRE ET MOYENS<br>DE PRODUCTION</div>
                <div class="donnee" v-if="fiche.cadres.contexte" v-html="fiche.cadres.contexte"></div>
                <div class="donnee" v-if="fiche.cadres.references" v-html="fiche.cadres.references"></div>
                <div class="donnee" v-if="fiche.cadres.raison" v-html="fiche.cadres.raison"></div>
                <div class="donnee" v-if="fiche.cadres.destinataire" v-html="fiche.cadres.destinataire"></div>
                <div v-if="fiche.cadres.moyens_humains || fiche.cadres.autres_moyens">MOYENS</div>
                <div class="donnee" v-if="fiche.cadres.moyens_humains" v-html="fiche.cadres.moyens_humains"></div>
                <div class="donnee" v-if="fiche.cadres.autres_moyens" v-html="fiche.cadres.autres_moyens"></div>
            </div>
    
            <div class="separation">
                <div class="sous_titre">PROCESSUS, FORMES,<br>RÉCEPTION</div>
                <div class="donnee" v-if="fiche.processus.processus" v-html="fiche.processus.processus"></div>
                <div class="donnee" v-if="fiche.processus.contenu" v-html="fiche.processus.contenu"></div>
                <div class="donnee" v-if="fiche.processus.formes" v-html="fiche.processus.formes"></div>
                <div class="donnee" v-if="fiche.processus.aboutissement" v-html="fiche.processus.aboutissement"></div>
                <div class="donnee" v-if="fiche.processus.portee" v-html="fiche.processus.portee"></div>
            </div>


            <svg class="imprimer" @click="imprimer()" version="1.1" id="Calque_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                 width="21.6px" height="22.2px" viewBox="0 0 21.6 22.2" style="enable-background:new 0 0 21.6 22.2;" xml:space="preserve">
                <rect x="1.4" y="5.5" class="st0" width="18.8" height="10.8"/>
                <rect x="5" y="12.1" class="st1" width="11.5" height="8.5"/>
                <rect x="5" y="1.4" class="st0" width="11.5" height="4.1"/>
                <line class="st1" x1="6.5" y1="16.3" x2="15.1" y2="16.3"/>
                <line class="st1" x1="6.5" y1="14.1" x2="15.1" y2="14.1"/>
                <line class="st1" x1="6.5" y1="18.5" x2="15.1" y2="18.5"/>
            </svg>

            <div class="fermer" @click="fermer()">fermer</div>
        </template>
    </div>
</template>

<script>

var supportsTouch = false;
var my_time = 1500; //ms : disappearance time

function checkForTouchstart(){
    if('ontouchstart' in window) {
        return true;
    }else if(window.navigator.msPointerEnabled) {
        if(navigator.msMaxTouchPoints) {
            return true;
        }else{
            return false;
        }
    }else{
        return false;
    }
}
var coord = {
    sx : null, sy : null,
    cx : null, cy : null,
    dx : null, dy : null,
    ex : null, ey : null,
    index : 0, margin : 90
};

    import { state } from '../../main.js';
    import { url_liste_objets, url_base } from '../../variables.js'

    export default {
        data() {
            return {
                slug: "",
                fiche: [],
                mots_clefs: state.mots_clefs,
                loaded: false,
                legende: false
                // vue_principale: state.vue_principale,
                // modal_ajout: state.modal_ajout,
                // modal_objet: state.modal_objet
            }
        },

        components: {
            // 'v-mots-clefs': MotsClefs
        },

        created: function() {
            this.slug = this.$route.params.projet;
            this.chercherObjets();

            /// IMPRESSION
            var beforePrint = function() {
                $("html, body").css({"height":1020,"width":763});
                //alert("before");
            };
            var afterPrint = function() {
                 $("html, body").css({"width":"","height":""});
                 //alert("after")
            };
            
            if (window.matchMedia) {
                var mediaQueryList = window.matchMedia('print');
                mediaQueryList.addListener(function(mql) {
                    if (mql.matches) {
                        beforePrint();
                    } else {
                        afterPrint();
                    }
                });
            }
            window.onafterprint = afterPrint;
        },
        watch: {
            '$route.params.projet'(cible) {
                this.slug = cible;
                this.loaded = false;
                this.chercherObjets();
            },
        },

        methods: {
            showContextual(event){
                //console.log(event);
            },
            moveContextual(event){
                //console.log(event.target);
            },
            hideContextual(event){
                //console.log(event);
            },
            contextual_chercherObjets(slug) {
                this.axios.get(url_liste_objets + slug).then((response) => {
                    this.fiche = response.data;
                    //console.log(this.fiche);
                    document.querySelector(".volet_projet").scrollTop = 0;
                    coord.index = 0;
                    this.loaded = true;
                });
            },
            checkForMobile: function(event) {
                //console.log(event);
                if(event.clientX <= 39){
                    //console.log(event.clientX);
                    this.$router.push(url_base + this.$route.params.vue);
                }
            },
            chercherObjets() {
                this.axios.get(url_liste_objets + this.slug).then((response) => {
                    this.fiche = response.data;
                    //console.log(this.fiche);
                    document.querySelector(".volet_projet").scrollTop = 0;
                    coord.index = 0;
                    this.loaded = true;
                });
            },
            retour_duree: function(jours) {
                if (jours > (365*1.5)) {
                    return Math.round((jours/365))+" ans";
                } else if (jours > 365) {
                    return Math.round((jours/365))+" an";
                } else if (jours > 32) {
                    return Math.round((jours/31))+" mois";
                } else {
                    return Math.round(jours) +" jours";
                }
            },
            retour_budget: function(budget) {
                return parseInt(budget).toLocaleString()+" euros";
            },
            disableDrag(event){
                event.preventDefault();
                return false;
            },
            disableSelect(event){
                event.preventDefault();
                return false;
            },
            showLegend(){
                /*for(var a = 0; a < document.getElementsByClassName("legende_active").length; ++a){
                    document.getElementsByClassName("legende_active")[a].classList.remove("legende_active");
                }
                document.getElementById("legende-"+coord.index).classList.add("legende_active");*/
                document.getElementsByClassName("legende_image_mobilum")[0].classList.add("legende_active");

            },
            hideLegend(){
                /*for(var a = 0; a < document.getElementsByClassName("legende_active").length; ++a){
                    document.getElementsByClassName("legende_active")[a].classList.remove("legende_active");
                }*/ 
                document.getElementsByClassName("legende_image_mobilum")[0].classList.remove("legende_active");
            },
            getXY(event) {
                var len = document.getElementsByClassName("images")[0].getElementsByTagName("img").length;
                coord.index = parseInt(document.getElementsByClassName("images")[0].getAttribute("data-index"));
                if(event.type == "touchstart"){
                    coord.sx = event.changedTouches[0].clientX;
                }
                if(event.type == "mousedown"){
                    coord.sx = event.clientX;
                }
                coord.handle = true;
                document.getElementsByClassName("images")[0].getElementsByTagName("div")[0].style.transition = "0ms";
                var tar = document.getElementsByClassName("image-block")[coord.index].getElementsByClassName("legende_image")[0];
                document.getElementsByClassName("legende_image_mobilum")[0].innerHTML = tar.innerHTML;
                if(len > 1){
                    console.log("get",coord.index);
                }
            },
            followXY(event) {
                if(event.type == "touchmove"){
                    coord.cx = event.changedTouches[0].clientX;
                }
                if(event.type == "mousemove"){
                    coord.cx = event.clientX;
                    coord.cy = event.clientY;
                    var l = document.getElementsByClassName("images")[0].getBoundingClientRect().left,
                    w = document.getElementsByClassName("images")[0].offsetWidth;
                    if(coord.cx > (l+(w/2))){
                        //console.log("right");
                        document.getElementsByClassName("images")[0].className = "images images-right";
                    }
                    if(coord.cx < (l+(w/2))){
                        //console.log("left");
                        document.getElementsByClassName("images")[0].className = "images images-left";
                    }
                }
                if(coord.handle == true){
                    coord.dx = coord.cx - coord.sx;
                }

                var curr_diff_fraction = (document.getElementsByClassName("images")[0].offsetWidth*coord.index*-1);
                var max = document.getElementsByClassName("images")[0].getElementsByTagName("img").length - 1;
                var calculus = curr_diff_fraction + coord.dx;
                if(coord.index == 0 && coord.dx > 0){}else if(coord.index == max && coord.dx < 0){}else{
                    if(coord.handle == true){
                        document.getElementsByClassName("images")[0].getElementsByTagName("div")[0].style.transform = "translateX("+calculus+"px)";;
                    }
                }
                if(event.type == "mousemove" || event.type == "touchmove"){
                    var tar = document.getElementsByClassName("image-block")[coord.index].getElementsByClassName("legende_image")[0];
                    document.getElementsByClassName("legende_image_mobilum")[0].style.left = coord.cx + "px";
                    document.getElementsByClassName("legende_image_mobilum")[0].style.top = coord.cy + "px";
                    document.getElementsByClassName("legende_image_mobilum")[0].innerHTML = tar.innerHTML;
                }
                    //document.getElementsByClassName("legende_image_mobilum")[0].classList.remove("legende_active");
                //console.log(coord.index);
            },
            leaveXY(event) {
                var len = document.getElementsByClassName("images")[0].getElementsByTagName("img").length;

                if(coord.dx <= coord.margin * -1){
                    coord.index++;
                }else if(coord.dx >= coord.margin){
                    coord.index--;
                }

                var max = document.getElementsByClassName("images")[0].getElementsByTagName("img").length - 1;
                if(coord.index < 0){
                    coord.index = 0;
                }else if(coord.index >= max){
                    coord.index = max;
                }
                document.getElementsByClassName("images")[0].setAttribute("data-index",coord.index);
                var calculus = (document.getElementsByClassName("images")[0].offsetWidth*coord.index*-1);
                document.getElementsByClassName("images")[0].getElementsByTagName("div")[0].style.transition = "250ms";
                setTimeout(function(){
                    document.getElementsByClassName("images")[0].getElementsByTagName("div")[0].style.transform = "translateX("+calculus+"px)";
                },50);

                if(event.type == "touchend"){
                    coord.ex = event.changedTouches[0].clientX;
                }
                if(event.type == "mouseup"){

                    coord.ex = event.clientX;
                    coord.dx = coord.ex - coord.sx;
                    if(coord.dx >= 10*-1 && coord.dx <= 10){
                        var l = document.getElementsByClassName("images")[0].getBoundingClientRect().left,
                        w = document.getElementsByClassName("images")[0].offsetWidth;
                        if(coord.ex > (l+(w/2))){
                            coord.index++;
                            //right
                        }
                        if(coord.ex < (l+(w/2))){
                            coord.index--;
                            //left
                        }
                    }
                    var max = document.getElementsByClassName("images")[0].getElementsByTagName("img").length - 1;
                    if(coord.index < 0){
                        coord.index = 0;
                    }else if(coord.index >= max){
                        coord.index = max;
                    }
                    document.getElementsByClassName("images")[0].setAttribute("data-index",coord.index);
                    var calculus = (document.getElementsByClassName("images")[0].offsetWidth*coord.index*-1);
                    document.getElementsByClassName("images")[0].getElementsByTagName("div")[0].style.transition = "250ms";
                }
                if(len > 1){
                    console.log("goto",coord.index,"/",len);
                }

                setTimeout(function(){
                    document.getElementsByClassName("images")[0].getElementsByTagName("div")[0].style.transform = "translateX("+calculus+"px)";
                    var tar = document.getElementsByClassName("image-block")[coord.index].getElementsByClassName("legende_image")[0];
                    document.getElementsByClassName("legende_image_mobilum")[0].innerHTML = tar.innerHTML;
                },50);
                if(event.type == "mouseleave"){
                    //document.getElementsByClassName("legende_image_mobilum")[0].classList.remove("legende_active");
                }
                coord.handle = false;
                coord.dx = null;
                coord.sx = null;
                coord.ex = null;
                /*coord.index = 0;*/
                //console.log(coord.index);
            },
            defiler_images(index) {
                if (index + 1 < this.fiche.images.length) {
                    index++;
                } else {
                    index = 0;
                }

                for (var i = 0; i < this.fiche.images.length; i++) {
                    this.fiche.images[i].active = false;
                    coord.index = index;
                }
                this.fiche.images[index].active = true;
            },
            deplacer_legende(event) {
                //show the right image
                /*$(".legende_image").css({
                    "left": event.layerX,
                    "top": event.layerY
                });*/
                //console.log(event);
            },
            afficher_acteur(id) {
                var url_actors = url_base + "acteurs";
                var target = document.getElementsByClassName("acteurs")[0];
                var item = null;
                if(document.getElementById("actor-"+id)){
                    item = document.getElementById("actor-"+id);
                }
                if(item && item != null){
                    this.$router.push(url_actors);
                    item.classList.add("actor-searched");
                    var scrollY = item.offsetTop - 200; //margin from top of window
                    target.scrollTo(0,scrollY);
                    setTimeout(function(){
                        item.classList.remove("actor-searched");
                    },my_time);
                }else{}
            },
            afficher_lieu(fiche){
                //console.log(fiche.id, fiche.slug, fiche.positions);
                var id = fiche.id;
                var url_projets = url_base + "interventions";
                var target = document.getElementsByClassName("interventions")[0];
                var item = null;
                if(document.getElementById("intervention-"+id)){
                    item = document.getElementById("intervention-"+id);
                }
                if(item && item != null){
                    this.$router.push(url_projets);
                    var col = document.getElementById("colonne-lieu_abrege");
                    var mode = col.getElementsByTagName("span")[0];
                    col.click();
                    target.scrollTo(0,0);
                    setTimeout(function(){
                        if(mode){
                            if(mode.classList.contains("desc")){
                                col.click();
                            }else if(mode.classList.contains("asc")){}
                        }
                    },500);
                    setTimeout(function(){
                        item.classList.add("intervention-searched");
                        var scrollY = item.offsetTop - 200; //margin from top of window
                        target.scrollTo(0,scrollY);
                        setTimeout(function(){
                            item.classList.remove("intervention-searched");
                        },my_time);
                    },1000);
                }else{}
            },
            afficher_annee(fiche){
                /*version interventions + fiches même année classées/groupées */
                console.log(fiche);
                if(window.innerWidth >= 750){
                    var url_projets = url_base + "chronologie";

                    var year = fiche.annee;
                    console.log(year);
                    if(year.includes("—")){
                        var cyear = year.split("—");
                        year = cyear[cyear.length-1];
                    }

                    var item = null;
                    var target = document.getElementsByClassName("chronologie")[0];

                    if(document.getElementById("year-"+year)){
                        item = document.getElementById("year-"+year);
                    }
                    console.log(item);
                    if(item && item != null){
                        this.$router.push(url_projets);
                        setTimeout(function(){
                            item.classList.add("year-searched");
                            var scrollY = item.offsetTop - 200; //margin from top of window
                            target.scrollTo(0,scrollY);
                            setTimeout(function(){
                                item.classList.remove("year-searched");
                            },my_time);
                        },500);
                    }
                }
                /*var id = fiche.id;
                var url_projets = url_base + "interventions";
                var target = document.getElementsByClassName("interventions")[0];
                var item = null;
                if(document.getElementById("intervention-"+id)){
                    item = document.getElementById("intervention-"+id);
                }
                if(item && item != null){
                    this.$router.push(url_projets);
                    var col = document.getElementById("colonne-annee");
                    var mode = col.getElementsByTagName("span")[0];
                    col.click();
                    target.scrollTo(0,0);
                    setTimeout(function(){
                        if(mode){
                            if(mode.classList.contains("asc")){
                                    col.click();
                            }
                        }
                    },500);
                    setTimeout(function(){
                        item.classList.add("intervention-searched");
                        var scrollY = item.offsetTop - 200; //margin from top of window
                        target.scrollTo(0,scrollY);
                        setTimeout(function(){
                            item.classList.remove("intervention-searched");
                        },my_time);
                    },500);
                }else{}*/
            },
            imprimer() {
                window.print();
            },
            fermer() {
                this.$router.push(url_base + this.$route.params.vue) // RETOUR À L'URL DE LA VUE PRECEDENTE
                //console.log(this.$route.params.vue);
            },
            goToMotCle(key){
                console.log(key);
                if(window.innerWidth >= 750){
                    var target = document.getElementById("mots_clefs");
                    var id = "keyword-"+key.id;
                    var url_projets = url_base + "mots_clefs";
                    var item = document.getElementById(id);

                    console.log(item);

                    if(item && item != null){
                        this.$router.push(url_projets);
                        setTimeout(function(){
                            item.classList.add("keyword-searched");
                            var scrollY = item.offsetTop - 200; //margin from top of window
                            target.scrollTo(0,scrollY);
                            setTimeout(function(){
                                item.classList.remove("keyword-searched");
                            },my_time);
                        },500);
                    }
                }
            }

        }
    };

</script>

<style>
    .volet_projet {
        position: absolute;
        top: 0;
        right: 0;
        width: calc(40vw);
        height: 100vh;
        padding-left: var(--tbm);
        padding-right: var(--tbm);
        padding-bottom: 200px;
        background-color: white;
        z-index: 3;
        border-left: 2px solid black;
        overflow: auto;
        -ms-overflow-style: none;  /* IE and Edge */
        scrollbar-width: none;  /* Firefox */
        user-select: text;
        -webkit-user-select: text;
        z-index: 13;
        /*transform: translateX(-10px);*/
    }
    #mots_clefs .volet_projet{
        position: fixed;
        right: calc(39px * 3);
    }
    .volet_projet {
        /*position: fixed;*/
    }
    #mots_clefs .volet_projet{
        /*right: calc(36px * 3);*/
    }

    .volet_projet::-webkit-scrollbar,
    .volet_projet::-webkit-scrollbar {
      display: none;
    }


    .titre-projet {
        text-transform: uppercase;
        width: auto;
        white-space: normal;
        position: relative;
        left: 0px;
        padding-right: 55px;
        font-size: var(--corps-titre);
        line-height: var(--interlignage-titre);
        margin-top: 6.5px; /*ici*/
    }

    .separation {
        display: block;
        float: left;
        clear: both;
        border-top: 2px solid black;
        padding-top: var(--tbm);
        margin-top: 1em;
        width:100%;
    }

    .sous_titre {
        text-align: center;
        margin-bottom: var(--interlignage-courant);
       /* margin-top: -2px;*/
    }

    .donnee {
        position: relative;
        margin-bottom: 1em;
        width: 100%;
        white-space: normal;
        text-align: left;
        background-color: transparent;
    }

    .colonne {
        float: left;
        clear: none;
    }

    .col2 {
        width: 60%;
        margin-right: 5%;
    }

    .col1 {
        width: 32%;
    }

    .categories ul,
    .categories li {
        display: inline-block;
        list-style: none;

    }

    ul {
        display: inline;
    }

    ul.mots_clefs {
        display: inline-block;
    }




    .images {
        /*position: relative;*/
        margin-top: 0px;
        margin-bottom: 10px;
        width: 100%;
        /*cursor: grab;*/
        cursor: none;
    }
    .legende_image_mobilum:before{
        position: absolute;
        margin-top: calc(-30px);
        margin-left: calc(-10px);
        font-size: var(--corps-titre);
        mix-blend-mode: difference;
    }
    .images-right .legende_image_mobilum:before{
        content: "→";
    }
    .images-left .legende_image_mobilum:before{
        content: "←";
    }

    .images>img {
        max-width: 100%;
        max-height:500px;
        cursor: e-resize;
        border:1px solid black;
    }

    .image_vide {
        width: 100%;
        border-top:2px solid black;
        margin-top:2em;
        height:0px;
        /*height: 0px;
        //background-color: grey;*/
    }

    /*.donnee_acteur+.donnee_acteur::before {
        content: ",\a0";
        padding:0;
        margin-left:0px;
    }*/

    p {
        margin-block-start:0px;
        margin-block-end:0px;
        /*margin:0 !important;
        padding:0 !important;*/
    }



    .fermer, .imprimer {
        position: absolute;
        top: 0;
        right: 0;
        display: block;
        width: 39px;
        height: 39px;
        font-size: 0;
        cursor: pointer;
        pointer-events: auto;
        z-index: 2;
        transition: opacity 0.2s ease-out;
    }

    .fermer:hover,
    .imprimer:hover {
        opacity: 0.5;
    }
    .imprimer {
        top:0px;
        right:38px;
        width:22px;
    }

    .fermer:before,
    .fermer:after {
        position: absolute;
        top: 50%;
        left: 50%;
        width: 5px;
        height: 20px;
        background-color: black;
        transform: rotate(45deg) translate(-50%, -50%);
        transform-origin: top left;
        content: '';
    }

    .fermer:after {
        transform: rotate(-45deg) translate(-50%, -50%);
    }

    .fermer:before,
    .fermer:after {
        width: 2px;
    }

    .fermer:before,
    .fermer:after {
        height: 24px;
    }

    svg .st0{fill:none;stroke:#000000;stroke-width:1.2;}
    svg .st1{fill:#FFFFFF;stroke:#000000;stroke-width:1.2;}

    /*
    .legende_image {
        position:absolute;
        transform:rotate(-90deg);
        bottom:6px;
        padding-top:3px;
        right:-206px;
        width:200px;
        transform-origin: bottom left;
    }
    */
    .legende_image {
        position: absolute;
        top:0px;
        left:0px;
        display:none;
        pointer-events:none;
        margin-left: var(--lrm);
        margin-top: 30px;
        font-size: 11px;
        white-space:nowrap;
    }
    .legende_image_mobilum{
        position: fixed;
        top:0px;
        left:0px;
        display:none;
        pointer-events:none;
        margin-left: var(--lrm);
        margin-top: 30px;
        font-size: 11px;
        white-space:nowrap;
    }
    .legende_image_mobilum > span {
        padding: 8px 5px 5px 5px;
        background-color:white;
    }

    .legende_image > span {
        padding:8px 5px 5px 5px;
        background-color:white;
    }

    .legende_active {
        display:block;
    }

    /*jdb*/
    .donnee_year:hover{
        cursor: pointer;
        text-decoration: underline;
    }
    .actor-searched{ color: red; }
    .acteur{ transition: 100ms; }

    .intervention-searched{ color: white; }
    .intervention{ transition: 100ms; }
    .donnee_lieu{
        display: table;
    }
    div.donnee > div > span.donnee_lieu:first-of-type{
        /*background-color: red;*/
        /*margin-top: var(--interlignage-courant);*/
    }
    .donnee_lieu:hover > span{
        cursor: pointer;
        text-decoration: none;
    }
    span.donnee_lieu:hover .contextual_wrapper{
        display: block;
    }
    span.donnee_lieu .contextual_wrapper{
        display: none;
    }
    .contextual_wrapper div{
        box-shadow: 0 0 0 1px black;
        cursor: pointer;
        padding: 4px 4px;
        position: absolute;
        background-color: white;
    }
    .contextual_wrapper div:hover{
        background-color: black;
        color: white;
    }
    .bubble, .year-label{
        transition: 100ms;
    }
    .year-searched .bubble{
        background-color: white;
    }
    .year-searched .year-label{
        color: white;
    }
    .mots_clefs > li{
        cursor: pointer;
    }
    .mots_clefs li span:hover{
        text-decoration: underline;
    }
    .mots_clefs li+li::before, .donnee_acteurs li+li::before {
        content: "—\a0";
        margin-left: 4px;
        cursor: default;
    }
    ul.donnee_acteurs{
        display: inline-block;
    }
    .donnee_acteurs li{
        display: inline;
        cursor: pointer;
    }
    .donnee_acteurs li span:hover{
        text-decoration: underline;
    }
</style>